import { useCallback } from 'react';
import { getWindow } from '../getWindow';
import { getCompactImageAlias, getGridImageAlias } from './getGridImageAlias';
import type { MDSAliases } from './getMdsUrl';

/** Возвращает оптимизированные алиасы для сеток и превью */
export function useGridImageOptimizer() {
    const dpr = getWindow()?.devicePixelRatio || 1;

    const getAlias = useCallback(
        (cardWidth?: number): MDSAliases | undefined =>
            cardWidth === undefined ? undefined : getGridImageAlias(cardWidth, dpr),
        [dpr],
    );

    const getCompactAlias = useCallback(
        (cardWidth: number): MDSAliases | undefined => getCompactImageAlias(cardWidth, dpr),
        [dpr],
    );

    return { getAlias, getCompactAlias };
}
